import * as React from 'react';
import './index.css';
import { RichText } from '@wmfe/mach-pro-components-react';
import { highlightListForText } from '@/common/Highlight';

interface IState {}

interface Props {
  model: any;
}

export default class DeliveryTimeItemView extends React.Component<Props, IState> {
  render() {
    const { model } = this.props;
    const textName = model.textName;
    const icon = model.icon;
    return (
      <view className="delivery-time-item-container">
        <view className="delivery-time-item-icon-wrapper" style={{ top: Mach.env.isIOS ? 0 : 0.5 }}>
          <image className="delivery-time-item-icon" src={icon} />
        </view>
        <view className="delivery-time-item-text-wrapper">
          <text className="delivery-time-item-text" content={textName} />
        </view>
      </view>
    );
  }
}
